import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
// toastify
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./screens/Dashboard/Dashboard";
import Languages from "./screens/Languages/Languages";
import AllLanguages from "./screens/Languages/AllLanguages";
import Categories from "./screens/Categories/Categories";
import AddLanguage from "./screens/Languages/AddLanguage";
import AllCategories from "./screens/Categories/AllCategories";
import AddCategory from "./screens/Categories/AddCategory";
import Users from "./screens/Users/Users";
import AddUser from "./screens/Users/AddUser";
import AllUsers from "./screens/Users/AllUsers";
import Videos from "./screens/Videos/Videos";
import Churches from "./screens/Churches/Church";
import AllChurches from "./screens/Churches/AllChurches";
import AddChurches from "./screens/Churches/AddChurch";
import Ministries from "./screens/Ministry/Ministry";
import AllMinistry from "./screens/Ministry/AllMinistry";
import AddMinistry from "./screens/Ministry/AddMinistry";
import Channel from "./screens/Channel/channel";
import AllChannel from "./screens/Channel/allchannel";
import AddChannel from "./screens/Channel/addchannel";
import Program from "./screens/Program/Program";
import AllProgram from "./screens/Program/AllProgram";
import AddProgram from "./screens/Program/AddProgram";
import Carecells from "./screens/Carcells/carcells";
import AllCarecells from "./screens/Carcells/allcarcells";
import AddCarecells from "./screens/Carcells/addcarcells";
import Campus from "./screens/Campus/campus";
import AllCampus from "./screens/Campus/allcampus";
import AddCampus from "./screens/Campus/addcampus";
import Team from "./screens/Teams/Teams";
import AllTeam from "./screens/Teams/AllTeam";
import AddTeam from "./screens/Teams/AddTeam";
import Events from "./screens/Events/events";
import AllEvent from "./screens/Events/Allevent";
import AddEvent from "./screens/Events/Addevent";
import AllVideos from "./screens/Videos/AllVideos";
import Curriculum from "./screens/Curriculum/Curriculum";
import AllCurriculum from "./screens/Curriculum/AllCurriculum";
import Givings from "./screens/Givings/Givings";
import AllGivings from "./screens/Givings/AllGivings";
import Twg from "./screens/TWG/Twg";
import AllTwg from "./screens/TWG/AllTwg";
import TestingTabs from "./components/categories/AddCategoryFields";
import Testimonials from "./screens/Testimonials/Testimonials";
import AllTestimonials from "./screens/Testimonials/AllTestimonials";
import AddCurriculum from "./screens/Curriculum/AddCurriculum";
import NotificationsList from "./screens/NotificationList/NotificationsList";
import AddNotifications from "./screens/NotificationList/AddNotifications";
import AddVideos from "./screens/Videos/AddVideos";
import AddTwg from "./screens/TWG/AddTwg";
import LoginPage from "./screens/login/LoginPage";
import ValidateUserAccess from "./screens/login/ValidateUserAccess";
import UnauthorizedAccess from "./screens/login/UnauthorizedAccess";
import MyProfile from "./components/profileMenu/MyProfile";
import Layout from "./screens/Layout/Layout";
import AddLayout from "./screens/Layout/AddLayout";
import AllLayouts from "./screens/Layout/AllLayouts";
import Feedback from "./screens/Feedback/Feedback";
import Prayers from "./screens/Prayers/Prayers";
import SessionExpired from "./components/universal/SessionExpired";
import UserProfileV2 from "./components/profileMenu/UserProfileV2";
import Analytics from "./screens/Analytics/Analytics";
import CloudflareVideos from "./screens/Cloudflare/CloudflareVideos";
import TestimonyCategory from "./screens/TestimonyCategory/TestimonyCategory";
import Addfield from "./screens/AddFields/Addfield";
import Journals from "./screens/Journals/Journals";
import AddJournals from "./screens/Journals/AddJournals";
import AllJournals from "./screens/Journals/AllJournals";
import AddMinistryField from "./screens/AddMinistry/AddMinistry"
import AddChannelField from "./screens/AddChannels/addChannel"
import PlanDetails from "./screens/Groups/groupDetails"
import Plans from "./screens/Plans/Plans";
import AllPlans from "./screens/Plans/AllPlans";
import AddPlans from "./screens/Plans/AddPlans";
import SermonPlans from "./screens/SermonPlans/SermonPlans";
import AllSermonPlans from "./screens/SermonPlans/AllSermonPlans";
import AddSermonPlans from "./screens/SermonPlans/AddSermonPlans";
import Agreements from "./screens/Agreements/Agreements";
import AgreementsAll from "./screens/Agreements/AgreementsAll";
import AgreementsAnalytics from "./screens/Agreements/AgreementsAnalytics";
import AgreementConsent from "./screens/Agreements/AgreementConsent";
import { fetchChurchesRequest } from "./store/Churches/actions";
import { ImCross } from "react-icons/im";
import {
  getDefaultRouteForAccess,
  getCurrentHostMode,
  getPortalRootUrlForAccess,
  isPathAllowedForAccess,
  resolveProfilePortalAccess,
} from "./utils/portalAccess";
import AuthTokenProvider from "./components/AuthTokenProvider";

function UnauthorizedPortalRedirect({ access }) {
  const targetLabel =
    access === "church" ? "Church" : access === "channel" ? "Channel" : access === "ministry" ? "Ministry" : "CMS";

  useEffect(() => {
    const shouldRedirect = window.confirm(
      `You are unauthorized to access this portal. Can I redirect you to ${targetLabel} admin?`
    );
    if (shouldRedirect) {
      window.location.href = getPortalRootUrlForAccess(access);
    } else {
      window.location.href = "/logout";
    }
  }, [access, targetLabel]);

  return null;
}

function EntityWorkspaceLoading({ entityConfig }) {
  const label = entityConfig?.label || "Workspace";

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-[92%] max-w-lg rounded-2xl border border-greyishV2 border-opacity-50 bg-blackishV2 p-8 text-white shadow-2xl">
        <div className="mb-5 flex items-center gap-3">
          <div className="h-10 w-10 animate-pulse rounded-full bg-yellowish/30" />
          <div>
            <p className="text-lg font-semibold">Loading {label} workspace</p>
            <p className="text-xs text-greyish">Checking assigned {label.toLowerCase()} data...</p>
          </div>
        </div>
        <div className="space-y-3">
          <div className="h-4 w-full animate-pulse rounded bg-greyishV2/40" />
          <div className="h-4 w-10/12 animate-pulse rounded bg-greyishV2/30" />
          <div className="grid grid-cols-3 gap-3 pt-3">
            <div className="h-20 animate-pulse rounded-xl bg-greyishV2/25" />
            <div className="h-20 animate-pulse rounded-xl bg-greyishV2/25" />
            <div className="h-20 animate-pulse rounded-xl bg-greyishV2/25" />
          </div>
        </div>
      </div>
    </div>
  );
}

const SUPER_ADMIN_ROLE = "39stc8";

function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const { userInfo, accessToken } = useSelector((state) => state.user);
  const { churches: entityRecords = [], loading: entityLoading = false } = useSelector(
    (state) => state.churches || {}
  );
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const token = accessToken || localStorage.getItem("token");
  const [consentResolved, setConsentResolved] = useState(false);
  const [entityCheckDone, setEntityCheckDone] = useState(false);
  const [entityCheckStarted, setEntityCheckStarted] = useState(false);
  const [entityCount, setEntityCount] = useState(null);
  const [showEntityWelcome, setShowEntityWelcome] = useState(false);
  const [entityWelcomeDismissed, setEntityWelcomeDismissed] = useState(false);

  const portalAccess = useMemo(
    () => resolveProfilePortalAccess(userInfo || {}),
    [userInfo]
  );

  const entityConfig = useMemo(() => {
    if (userInfo?.roleCode === SUPER_ADMIN_ROLE || portalAccess === "all") {
      return null;
    }

    switch (userInfo?.roleName) {
      case "Church Admin":
        return {
          type: "1",
          label: "Church",
          addRoute: "/addfield",
          storageKey: "church",
        };
      case "Channel Admin":
        return {
          type: "2",
          label: "Channel",
          addRoute: "/addChannelField",
          storageKey: "channel",
        };
      case "Ministry Admin":
        return {
          type: "3",
          label: "Ministry",
          addRoute: "/addMinistryField",
          storageKey: "ministry",
        };
      default:
        return null;
    }
  }, [portalAccess, userInfo?.roleCode, userInfo?.roleName]);

  const displayName =
    [userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(" ") ||
    userInfo?.name ||
    userInfo?.email ||
    "User";

  useEffect(() => {
    setConsentResolved(false);
    setEntityCheckDone(false);
    setEntityCheckStarted(false);
    setEntityCount(null);
    setShowEntityWelcome(false);
    setEntityWelcomeDismissed(false);
  }, [userInfo?._id]);

  useEffect(() => {
    if (!entityConfig?.type) return;
    const key = `entityWelcomeDismissed:${entityConfig.type}`;
    setEntityWelcomeDismissed(localStorage.getItem(key) === "1");
  }, [entityConfig?.type]);

  useEffect(() => {
    if (entityConfig?.addRoute && location.pathname.startsWith(entityConfig.addRoute)) {
      setShowEntityWelcome(false);
    }
  }, [location.pathname, entityConfig?.addRoute]);

  const hasPendingAgreements = useMemo(() => {
    if (!entityConfig?.type) return false;

    const statuses = userInfo?.agreementStatuses || [];
    const relevant = statuses.filter(
      (item) => String(item?.typeofentity || "") === String(entityConfig.type)
    );
    if (relevant.length === 0) {
      // If we don't have agreement status records yet, force consent check.
      return true;
    }
    return relevant.some((item) => {
      const status = String(item?.status);
      return status !== "1" || item?.requiresReaccept === true;
    });
  }, [entityConfig?.type, userInfo?.agreementStatuses]);

  const agreementsGateCleared = !hasPendingAgreements || consentResolved;
  const isOnEntityCreateRoute = entityConfig?.addRoute && path.startsWith(entityConfig.addRoute);
  const showEntityCheckLoading =
    Boolean(userInfo?._id) &&
    Boolean(entityConfig?.type) &&
    agreementsGateCleared &&
    !entityCheckDone &&
    !isOnEntityCreateRoute &&
    path !== "/profile";

  useEffect(() => {
    if (!userInfo?._id) return;
    if (!entityConfig?.type) return;
    if (!agreementsGateCleared) return;
    if (entityCheckDone || entityCheckStarted) return;

    let completed = false;
    const completeEntityCheck = (records) => {
      if (completed) return;
      completed = true;
      setEntityCount(Array.isArray(records) ? records.length : 0);
      setEntityCheckDone(true);
    };

    setEntityCheckStarted(true);
    const fallbackTimer = window.setTimeout(() => completeEntityCheck(entityRecords), 12000);

    dispatch(
      fetchChurchesRequest(
        { apiPayloadRequest: { typeofentity: entityConfig.type } },
        (res) => {
          window.clearTimeout(fallbackTimer);
          completeEntityCheck(res?.data);
        }
      )
    );

    return () => window.clearTimeout(fallbackTimer);
  }, [
    dispatch,
    userInfo?._id,
    entityConfig?.type,
    agreementsGateCleared,
    entityCheckDone,
    entityCheckStarted,
    entityRecords,
  ]);

  useEffect(() => {
    if (!entityCheckStarted) return;
    if (entityCheckDone) return;
    if (entityLoading) return;
    if (!Array.isArray(entityRecords)) return;

    setEntityCount(entityRecords.length);
    setEntityCheckDone(true);
  }, [entityCheckStarted, entityCheckDone, entityLoading, entityRecords]);

  useEffect(() => {
    if (!userInfo?._id) return;
    if (!entityConfig?.type) return;
    if (!agreementsGateCleared) return;
    if (!entityCheckDone) return;
    if (entityWelcomeDismissed) return;
    if (entityCount === 0) {
      setShowEntityWelcome(true);
    }
  }, [
    userInfo?._id,
    entityConfig?.type,
    agreementsGateCleared,
    entityCheckDone,
    entityWelcomeDismissed,
    entityCount,
  ]);

  // Allow initial auth bootstrap (Auth0/session token can be set after first render).
  if (!token && !userInfo?._id) {
    return children;
  }

  // If token exists but profile is not resolved yet, let screen load and fetch profile.
  if (!userInfo?._id) {
    return children;
  }

  if (userInfo?._id) {
    const access = portalAccess;
    const hostMode = getCurrentHostMode();

    // On entity-specific hosts, wrong-portal admin should be redirected to their own portal host.
    if (hostMode !== "cms" && access !== "all" && access !== "none") {
      const hostAccessMap = {
        churches: "church",
        channels: "channel",
        ministries: "ministry",
      };
      if (hostAccessMap[hostMode] !== access) {
        return <UnauthorizedPortalRedirect access={access} />;
      }
    }

    if (hasPendingAgreements && !consentResolved) {
      return <AgreementConsent onComplete={() => setConsentResolved(true)} />;
    }

    if (access === "none" && path !== "/unauthorized") {
      return <Navigate to="/unauthorized" replace />;
    }

    if (!isPathAllowedForAccess(path, access, hostMode)) {
      return <Navigate to={getDefaultRouteForAccess(access, hostMode)} replace />;
    }
  }
  return (
    <>
      {children}
      {showEntityCheckLoading && <EntityWorkspaceLoading entityConfig={entityConfig} />}
      {showEntityWelcome && entityConfig && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
          <div className="relative bg-blackishV2 text-white rounded-2xl border border-greyishV2 border-opacity-50 px-10 py-10 w-[92%] max-w-md text-center">
            <button
              className="absolute right-4 top-4 text-greyish hover:text-white"
              onClick={() => {
                const key = `entityWelcomeDismissed:${entityConfig.type}`;
                setShowEntityWelcome(false);
                setEntityWelcomeDismissed(true);
                localStorage.setItem(key, "1");
              }}
              aria-label="Close"
            >
              <ImCross size={12} />
            </button>
            <p className="text-2xl font-semibold mb-2">Welcome {displayName}</p>
            <p className="text-sm text-greyish mb-6">
              You need to add your {entityConfig.label.toLowerCase()} to get started.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                className="text-yellowish border border-yellowish bg-blackish px-6 py-2 rounded-xl text-[13px]"
                onClick={() => {
                  const key = `entityWelcomeDismissed:${entityConfig.type}`;
                  setShowEntityWelcome(false);
                  setEntityWelcomeDismissed(true);
                  localStorage.setItem(key, "1");
                  localStorage.removeItem(entityConfig.storageKey);
                  window.dispatchEvent(
                    new CustomEvent(`${entityConfig.storageKey}:change`, { detail: null })
                  );
                  navigate(entityConfig.addRoute, {
                    state: { church: null, mode: "create" },
                  });
                }}
              >
                Add {entityConfig.label}
              </button>
              <button
                className="text-greyish border border-greyish bg-blackish px-6 py-2 rounded-xl text-[13px]"
                onClick={() => {
                  const key = `entityWelcomeDismissed:${entityConfig.type}`;
                  setShowEntityWelcome(false);
                  setEntityWelcomeDismissed(true);
                  localStorage.setItem(key, "1");
                }}
              >
                Not Now
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <div>
      <AuthTokenProvider>
        <RouterProvider
        router={createBrowserRouter(
          createRoutesFromElements(
            <>
            {/* <Route exact path="/login-redirect" element={<LoginRedirectHandler />} /> */}

              <Route exact path="/login" element={<LoginPage />} />
              <Route exact path="/validate-user" element={<ValidateUserAccess />} />
              {/* logout on session or token expire */}
              <Route exact path="/logout" element={<SessionExpired />} />
              <Route exact path="/unauthorized" element={<UnauthorizedAccess />} />
              <Route exact path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

              {/* <Route exact path="/" element={<ProtectedHome />} /> */}
              {/* languages routes  */}
              {/* <Route exact path="/" element={<LoginRedirectHandler />} /> */}

              <Route exact path="/languages" element={<ProtectedRoute><Languages /></ProtectedRoute>}></Route>
              <Route exact path="/languages/all" element={<ProtectedRoute><AllLanguages /></ProtectedRoute>}></Route>
              <Route exact path="/languages/add" element={<ProtectedRoute><AddLanguage /></ProtectedRoute>}></Route>
              <Route exact path="/layout" element={<ProtectedRoute><Layout /></ProtectedRoute>}></Route>
              <Route exact path="/layout/all" element={<ProtectedRoute><AllLayouts /></ProtectedRoute>}></Route>
              <Route exact path="/layout/add" element={<ProtectedRoute><AddLayout /></ProtectedRoute>}></Route>
              {/* ends here */}
              {/* categories routes  */}
              <Route exact path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>}></Route>
              <Route exact path="/testing" element={<ProtectedRoute><TestingTabs /></ProtectedRoute>}></Route>
              <Route exact path="/categories/all" element={<ProtectedRoute><AllCategories /></ProtectedRoute>}></Route>
              <Route exact path="/categories/add" element={<ProtectedRoute><AddCategory /></ProtectedRoute>}></Route>
              <Route exact path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>}></Route>
              <Route exact path="/users/add" element={<ProtectedRoute><AddUser /></ProtectedRoute>}></Route>
              <Route exact path="/users/all" element={<ProtectedRoute><AllUsers /></ProtectedRoute>}></Route>
              <Route path="/users/:userID" element={<ProtectedRoute><UserProfileV2 /></ProtectedRoute>}></Route>
              <Route exact path="/videos" element={<ProtectedRoute><Videos /></ProtectedRoute>}></Route>
              <Route exact path="/videos/all" element={<ProtectedRoute><AllVideos /></ProtectedRoute>}></Route>
              <Route exact path="/videos/add" element={<ProtectedRoute><AddVideos /></ProtectedRoute>}></Route>
              <Route exact path="/plans" element={<ProtectedRoute><Plans /></ProtectedRoute>}></Route>
              <Route exact path="/plans/all" element={<ProtectedRoute><AllPlans /></ProtectedRoute>}></Route>
              <Route exact path="/plans/add" element={<ProtectedRoute><AddPlans /></ProtectedRoute>}></Route>
              <Route exact path="/sermon-plans" element={<ProtectedRoute><SermonPlans /></ProtectedRoute>}></Route>
              <Route exact path="/sermon-plans/all" element={<ProtectedRoute><AllSermonPlans /></ProtectedRoute>}></Route>
              <Route exact path="/sermon-plans/add" element={<ProtectedRoute><AddSermonPlans /></ProtectedRoute>}></Route>
              <Route exact path="/curriculum" element={<ProtectedRoute><Curriculum /></ProtectedRoute>}></Route>
              <Route exact path="/curriculum/all" element={<ProtectedRoute><AllCurriculum /></ProtectedRoute>}></Route>
              <Route exact path="/curriculum/add" element={<ProtectedRoute><AddCurriculum /></ProtectedRoute>}></Route>
              <Route exact path="/testimonials" element={<ProtectedRoute><Testimonials /></ProtectedRoute>}></Route>
              <Route exact path="/testimonials/all" element={<ProtectedRoute><AllTestimonials /></ProtectedRoute>}></Route>
              <Route exact path="/givings" element={<ProtectedRoute><Givings /></ProtectedRoute>}></Route>
              <Route exact path="/givings/all" element={<ProtectedRoute><AllGivings /></ProtectedRoute>}></Route>
              <Route exact path="/notificationsList" element={<ProtectedRoute><NotificationsList /></ProtectedRoute>}></Route>
              <Route exact path="/notificationsList/add" element={<ProtectedRoute><AddNotifications /></ProtectedRoute>}></Route>
              <Route exact path="/twg" element={<ProtectedRoute><Twg /></ProtectedRoute>}></Route>
              <Route exact path="/twg/all" element={<ProtectedRoute><AllTwg /></ProtectedRoute>}></Route>
              <Route exact path="/twg/add" element={<ProtectedRoute><AddTwg /></ProtectedRoute>}></Route>
              <Route exact path="/churches" element={<ProtectedRoute><Churches /></ProtectedRoute>}></Route>
              <Route exact path="/churches/all" element={<ProtectedRoute><AllChurches /></ProtectedRoute>}></Route>
              <Route exact path="/churches/add" element={<ProtectedRoute><AddChurches /></ProtectedRoute>}></Route>
              <Route exact path="/ministry" element={<ProtectedRoute><Ministries /></ProtectedRoute>}></Route>
              <Route exact path="/ministry/all" element={<ProtectedRoute><AllMinistry /></ProtectedRoute>}></Route>
              <Route exact path="/ministry/add" element={<ProtectedRoute><AddMinistry /></ProtectedRoute>}></Route>
              <Route exact path="/channels" element={<ProtectedRoute><Channel /></ProtectedRoute>}></Route>
              <Route exact path="/channel/all" element={<ProtectedRoute><AllChannel /></ProtectedRoute>}></Route>
              <Route exact path="/channel/add" element={<ProtectedRoute><AddChannel /></ProtectedRoute>}></Route>
              <Route exact path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>}></Route>
              <Route exact path="/event/all" element={<ProtectedRoute><AllEvent /></ProtectedRoute>}></Route>
              <Route exact path="/event/add" element={<ProtectedRoute><AddEvent /></ProtectedRoute>}></Route>
              <Route exact path="/programs" element={<ProtectedRoute><Program /></ProtectedRoute>}></Route>
              <Route exact path="/program/all" element={<ProtectedRoute><AllProgram /></ProtectedRoute>}></Route>
              <Route exact path="/program/add" element={<ProtectedRoute><AddProgram /></ProtectedRoute>}></Route>
              <Route exact path="/campus" element={<ProtectedRoute><Campus /></ProtectedRoute>}></Route>
              <Route exact path="/campus/all" element={<ProtectedRoute><AllCampus /></ProtectedRoute>}></Route>
              <Route exact path="/campus/add" element={<ProtectedRoute><AddCampus /></ProtectedRoute>}></Route>
              <Route exact path="/teams" element={<ProtectedRoute><Team /></ProtectedRoute>}></Route>
              <Route exact path="/team/all" element={<ProtectedRoute><AllTeam /></ProtectedRoute>}></Route>
              <Route exact path="/team/add" element={<ProtectedRoute><AddTeam /></ProtectedRoute>}></Route>
              <Route exact path="/carecells" element={<ProtectedRoute><Carecells /></ProtectedRoute>}></Route>
              <Route exact path="/carecell/all" element={<ProtectedRoute><AllCarecells /></ProtectedRoute>}></Route>
              <Route exact path="/carecell/add" element={<ProtectedRoute><AddCarecells /></ProtectedRoute>}></Route>
              <Route exact path="/profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>}></Route>
              <Route exact path="/prayers" element={<ProtectedRoute><Prayers /></ProtectedRoute>}></Route>
              <Route exact path="/agreements/consent" element={<ProtectedRoute><AgreementConsent /></ProtectedRoute>}></Route>
              <Route exact path="/cloudflarevideos" element={<ProtectedRoute><CloudflareVideos /></ProtectedRoute>}></Route>
              <Route exact path="/feedback" element={<ProtectedRoute><Feedback /></ProtectedRoute>}></Route>
              <Route exact path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>}></Route>
              <Route exact path="/agreements" element={<ProtectedRoute><AgreementsAnalytics /></ProtectedRoute>}></Route>
              <Route exact path="/agreements/analytics" element={<ProtectedRoute><AgreementsAnalytics /></ProtectedRoute>}></Route>
              <Route exact path="/agreements/all" element={<ProtectedRoute><AgreementsAll /></ProtectedRoute>}></Route>
              <Route exact path="/agreements/add" element={<ProtectedRoute><Agreements /></ProtectedRoute>}></Route>
              <Route exact path="/testimonycategory" element={<ProtectedRoute><TestimonyCategory /></ProtectedRoute>}></Route>
              <Route exact path="/addfield" element={<ProtectedRoute><Addfield /></ProtectedRoute>}></Route>
              <Route exact path="/addMinistryField" element={<ProtectedRoute><AddMinistryField /></ProtectedRoute>}></Route>
              <Route exact path="/addChannelField" element={<ProtectedRoute><AddChannelField /></ProtectedRoute>}></Route>
              <Route path='/group/:id' element={<ProtectedRoute><PlanDetails /></ProtectedRoute>}/>

              <Route exact path="/journals" element={<ProtectedRoute><Journals /></ProtectedRoute>}></Route>
              <Route exact path="/journals/all" element={<ProtectedRoute><AllJournals /></ProtectedRoute>}></Route>
              <Route exact path="/journals/add" element={<ProtectedRoute><AddJournals /></ProtectedRoute>}></Route>



            </>
          )
        )}
        />
      </AuthTokenProvider>

      <ToastContainer />
    </div>
  );
}

export default App;
